import { objectValues } from "@ea/shared_components/utils/object";

import globalSettingsEpicsMap from "./globalSettings.epics";
import * as globalSettingsReducers from "./globalSettings.reducers";

const globalSettingsEpics = objectValues(globalSettingsEpicsMap);

export { globalSettingsReducers, globalSettingsEpics };
